import type { Endorsement, ExpertiseArea } from '../types/resume';

export const expertiseAreas: ExpertiseArea[] = [
  {
    id: 'technology',
    name: 'Technology leadership & digital transformation',
    summary:
      'Leading IT areas and digital transformation processes, and connecting technology strategy with business priorities.',
    skills: [
      'IT management & direction',
      'Digital transformation',
      'Technology strategy aligned to business',
      'Change management',
      'Process innovation & optimization',
      'Customer-oriented & emerging AI-enabled solutions',
      'Organizational modernization',
    ],
    evidence: ['CIO, Megalabs Chile', 'Strategic Advisor, Momentum Consulting', 'LATAM Operations Manager, COSMO CONSULT'],
  },
  {
    id: 'platforms',
    name: 'Enterprise platforms & data',
    summary: 'ERP, BI and CRM programs, from cloud migration to regional delivery, plus cybersecurity initiatives.',
    skills: [
      'Microsoft Dynamics 365 ERP (cloud)',
      'Business Intelligence & Power BI',
      'Azure cloud BI platform',
      'CRM & eCommerce integration',
      'Data warehouse & database systems',
      'Security Operations Center (SOC) development',
      'Logistics control tower',
    ],
    evidence: ['CIO, Megalabs Chile', 'COSMO CONSULT', 'Sybase', 'Momentum Consulting'],
  },
  {
    id: 'governance',
    name: 'Governance, advisory & coaching',
    summary: 'Board-level governance and strategic advisory for organizations and leaders in transformation.',
    skills: [
      'Board governance & strategic oversight',
      'Long-term business strategy',
      'Leadership alignment',
      'Strategic planning',
      'Executive coaching',
      'Growth plans & financial planning',
    ],
    evidence: ['Chairman of the Board, Provectis', 'Momentum Consulting, 2004–2005 and 2022–present'],
  },
  {
    id: 'commercial',
    name: 'Commercial growth & channel development',
    summary: 'Regional sales, channel and market development with multinational technology vendors.',
    skills: [
      'Strategic sales management',
      'Channel development & strategic alliances',
      'Market development & demand generation',
      'Distributor & system-integrator models',
      'Strategic accounts & wholesalers',
      'New-market entry',
      'Solution selling',
    ],
    evidence: ['Intel Corporation', 'Sun Microsystems', 'Sybase', 'Synapsis'],
  },
  {
    id: 'product',
    name: 'Product management & marketing',
    summary: 'Product, brand and market positioning, from pricing and licensing to executive events.',
    skills: [
      'Product management',
      'Pricing, licensing & launches',
      'Corporate & brand positioning',
      'Product marketing',
      'Corporate communications & PR',
      'Business planning',
    ],
    evidence: ['Product Manager, Synapsis', 'Regional Marketing Manager, Sun Microsystems'],
  },
  {
    id: 'methods',
    name: 'Methodologies',
    summary: 'Combines agile and traditional delivery approaches to fit the organization and the project.',
    skills: ['Agile methodologies', 'Traditional project methodologies', 'Design Thinking', 'OKRs'],
    evidence: ['CIO, Megalabs Chile'],
  },
];

export const endorsements: Endorsement[] = [
  { name: 'Gestión de productos', translation: 'Product Management', count: 25 },
  { name: 'Product Management', count: 24, note: 'Endorsed by Eduardo Yon and 1 other who is highly skilled at this · 3 colleagues at Intel' },
  { name: 'Liderazgo de equipos', translation: 'Team Leadership', count: 19 },
  { name: 'Estrategia', translation: 'Strategy', count: 15 },
  { name: 'Strategy', count: 13, note: 'Endorsed by 2 colleagues at Intel' },
  { name: 'Estrategia empresarial', translation: 'Business Strategy', count: 12 },
  { name: 'Desarrollo empresarial', translation: 'Business Development', count: 12 },
  { name: 'Gestión de relaciones con clientes', translation: 'Customer Relationship Management', count: 11 },
  { name: 'Business Development', count: 10, note: 'Endorsed by Julian Blanco, who is highly skilled at this · 3 colleagues at Intel' },
  { name: 'Inteligencia empresarial', translation: 'Business Intelligence', count: 10 },
  { name: 'CRM', count: 5, note: 'Endorsed by 2 colleagues at Intel' },
  { name: 'Administración y dirección de empresas', translation: 'Business Administration', count: 5 },
  { name: 'Creación y desarrollo de empresas', translation: 'Business Creation', count: 5 },
  { name: 'Estrategias de mercado', translation: 'Market Strategies', count: 5 },
  { name: 'Venta de soluciones', translation: 'Solution Selling', count: 4 },
  { name: 'Channel Partners', count: 3 },
  { name: 'New Business Development', count: 3 },
  { name: 'Socios de canal', translation: 'Channel Partners', count: 3 },
  { name: 'Plan de negocio', translation: 'Business Plan', count: 3 },
  { name: 'Cloud Computing', count: 2 },
  { name: 'Go-to-market Strategy', count: 2 },
  { name: 'Planificación estratégica', translation: 'Strategic Planning', count: 2 },
  { name: 'Marketing de productos', translation: 'Product Marketing', count: 2 },
  { name: 'Computación en la nube', translation: 'Cloud Computing', count: 2 },
  { name: 'Solution Selling', count: 2 },
  { name: 'Marketing Strategy', count: 2 },
  { name: 'Retail', count: 1 },
  { name: 'Business Intelligence', count: 1 },
  { name: 'Estrategia de mercadotecnia', translation: 'Marketing Strategy', count: 1 },
  { name: 'Strategic Planning', count: 1, note: 'Endorsed by Marco Lauritano, who is highly skilled at this' },
];
